import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface ListLoadingSkeletonProps {
  count?: number;
  itemHeight?: string;
  className?: string;
}

export function ListLoadingSkeleton({
  count = 3,
  itemHeight = 'h-16',
  className,
}: ListLoadingSkeletonProps) {
  return (
    <div className={cn('space-y-3', className)}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className={cn(itemHeight, 'w-full')} />
      ))}
    </div>
  );
}
